import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../Contexts/AppContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import LoadingSpinner from "../../Loading/LoadingSpinner";
import EmptyData from "../../EmptyData";

const Products = () => {
  const context = useContext(AppContext);
  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [currentColor, setCurrentColor] = useState("");
  const [products, setProducts] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [width, setWidth] = useState(window.innerWidth);

  const getProducts = async () => {
    setIsLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_HONEY_URL}/products`,
      {
        method: "GET",
      }
    );
    const result = await response.json();
    setProducts(result);
    setIsLoading(false);
  };

  useEffect(() => {
    getProducts();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    setCurrentBG(
      context.isLight
        ? context.currentTheme["commerce"].bg
        : context.currentTheme["commerce"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["commerce"].text
        : context.currentTheme["commerce"].dark_text
    );
    setCurrentColor(
      context.isLight
        ? context.currentTheme["commerce"].dark_dropdown
        : context.currentTheme["commerce"].dropdown
    );

    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  }, [context]);
  return !isLoading ? (
    <div
      className="relative flex min-h-[calc(100vh-56px)] flex-col justify-center transition-all duration-500"
      style={{ backgroundColor: currentBG, color: currentText }}
    >
      <h1 className="mx-auto pb-10 text-4xl font-semibold">
        Our <span style={{ color: currentColor }}>Products</span>
      </h1>
      <>
        {products.length > 0 ? (
          <Swiper
            slidesPerView={width > 1024 ? 4 : width > 640 ? 2 : 1}
            spaceBetween={30}
            loop
            navigation
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            className="esper-products-swiper"
            modules={[Autoplay, Pagination, Navigation]}
          >
            {products.map((product, index) => (
              <SwiperSlide
                key={index}
                className="rounded-lg bg-[#ffca2c] shadow-lg"
                style={{ color: context.isLight ? currentText : currentBG }}
              >
                <img
                  src={product.avatar}
                  className="h-80 w-full rounded-t-lg object-cover ss:h-96"
                  alt="product"
                />
                <div className="relative p-2">
                  <div className="flex items-center justify-between">
                    <h3 className="">{product.title}</h3>
                    <p>1kg - ${product.price_1kg}</p>
                  </div>
                  <div className="flex items-center justify-between">
                    <p>{product.categories[0]}</p>
                    <p>500g - ${product.price_500g}</p>
                  </div>
                  <p
                    className="mt-2 ml-auto w-[6rem] rounded-full border-2 text-center text-sm font-semibold"
                    style={{
                      borderColor: currentBG,
                    }}
                  >
                    {product.type}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <EmptyData message="No Products Available now" />
        )}
      </>
    </div>
  ) : (
    <LoadingSpinner
      name="Products"
      bgColor={currentBG}
      text={currentText}
      isLight={context.isLight}
    />
  );
};

export default Products;
